<template>
  <div>
    <slot></slot>
    <button
      v-if="hasManyItems"
      @click="toggleVisibility"
      class="btn btn-sm btn-primary-link ml-n1 mt-1"
    >
      {{ isOpen ? t.show_less : t.show_more }}
    </button>
  </div>
</template>

<script>
export default {
  name: "FacetWrapper",
  props: {
    maxVisible: {
      required: false,
      type: Number,
      default: 10,
    },
    t: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      isOpen: false,
      items: this.$slots.default,
      hasManyItems: this.$slots.default ? this.$slots.default.length > this.maxVisible : false,
    };
  },
  computed: {
    overflowingItems() {
      if (!this.$slots.default) return null;
      return this.$slots.default.slice(this.maxVisible, this.$slots.default.length);
    },
  },
  mounted() {
    this.hideOverflowingItems();
  },
  methods: {
    hideOverflowingItems() {
      if (this.$slots.default) {
        this.overflowingItems.forEach(vnode => vnode.elm.classList.add("d-none"));
      }
    },
    setAllVisible() {
      this.items.forEach(vnode => vnode.elm.classList.remove("d-none"));
    },
    toggleVisibility() {
      this.isOpen ? this.hideOverflowingItems() : this.setAllVisible();
      this.isOpen = !this.isOpen;
    },
  },
};
</script>
